import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import TokenIcon from './TokenIcon';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message || 'Failed to log in. Please check your credentials.');
    } finally {
      setSubmitting(false);
    }
  };

  const inputStyles =
    'w-full bg-wp-bg border border-wp-border text-white placeholder-wp-muted rounded-xl px-4 py-3 text-[15px] focus:outline-none focus:ring-2 focus:ring-wp-accent';

  return (
    <div className="max-w-md mx-auto mt-10">
      <div className="text-center mb-8">
        <div className="flex justify-center mb-3"><TokenIcon size={72} flat={false} /></div>
        <h1 className="text-4xl font-bold text-white">WallPass</h1>
        <p className="text-wp-muted mt-2">One balance. Every paywall.</p>
      </div>

      <div className="bg-wp-surface rounded-2xl p-8">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-wp-muted text-sm font-medium mb-1.5">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={inputStyles}
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-wp-muted text-sm font-medium mb-1.5">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={inputStyles}
            />
          </div>
          {error && <p className="text-wp-danger text-sm text-center">{error}</p>}
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-wp-accent text-wp-bg font-semibold py-3 rounded-xl hover:opacity-80 transition-opacity disabled:opacity-50"
          >
            {submitting ? 'Logging in…' : 'Log In'}
          </button>
        </form>
        <p className="text-center text-sm text-wp-muted mt-4">
          Don&apos;t have an account?{' '}
          <Link to="/register" className="font-semibold text-wp-accent hover:opacity-80">Create one</Link>.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
